export const EVENT_TAG_ICONS = [
  {
    id: 'isTravelWorthy',
    icon: 'airport',
    transcode: 't_OGEVENTTAGTRAVELWORTHY',
  },
  {
    id: 'isTouring',
    icon: 'globe',
    transcode: 't_OGEVENTTAGTOURING',
  },
  {
    id: 'featured',
    icon: 'diamond',
    transcode: 't_OGEVENTTAGFEATURED',
  },
  {
    id: 'isStaffPick',
    icon: 'hand-star',
    transcode: 't_OGEVENTTAGSTAFFPICKS',
  },
];

export const EVENT_TYPES = {
  concert: {
    transcode: 't_OGEVENTTYPECONCERTS',
    icon: 'karaoke',
  },
  festival: {
    transcode: 't_OGEVENTTYPEFESTIVALS',
    icon: 'fireworks',
  },
  social: {
    transcode: 't_OGEVENTTYPESOCIAL',
    icon: 'hifive',
  },
  performance_show: {
    transcode: 't_OGEVENTTYPEPERFORMANCESHOW',
    icon: 'culture',
  },
  museum_exhibit: {
    transcode: 't_OGEVENTTYPEMUSEUMEXHIBIT',
    icon: 'landmark',
  },
  competition: {
    transcode: 't_OGEVENTTYPECOMPETITION',
    icon: 'trophy',
  },
  parade: {
    transcode: 't_OGEVENTTYPEPARADE',
    icon: 'flag',
  },
  convention_expo: {
    transcode: 't_OGEVENTTYPECONVENTIONEXPO',
    icon: 'travel-desk',
  },
  tour: {
    transcode: 't_OGEVENTTYPETOUR',
    icon: 'transfer',
  },
};

export const WORLDWIDE_CITIES_WITH_EVENTS = [
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Barcelona',
      urlFriendlyName: 'barcelona',
    },
    country: {
      name: 'Spain',
      urlFriendlyName: 'spain',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Amsterdam',
      urlFriendlyName: 'amsterdam',
    },
    country: {
      name: 'Netherlands',
      urlFriendlyName: 'netherlands',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Paris',
      urlFriendlyName: 'paris',
    },
    country: {
      name: 'France',
      urlFriendlyName: 'france',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Lisbon',
      urlFriendlyName: 'lisbon',
    },
    country: {
      name: 'Portugal',
      urlFriendlyName: 'portugal',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Berlin',
      urlFriendlyName: 'berlin',
    },
    country: {
      name: 'Germany',
      urlFriendlyName: 'germany',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'London',
      urlFriendlyName: 'london',
    },
    country: {
      name: 'England',
      urlFriendlyName: 'england',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Madrid',
      urlFriendlyName: 'madrid',
    },
    country: {
      name: 'Spain',
      urlFriendlyName: 'spain',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Rome',
      urlFriendlyName: 'rome',
    },
    country: {
      name: 'Italy',
      urlFriendlyName: 'italy',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Prague',
      urlFriendlyName: 'prague',
    },
    country: {
      name: 'Czech Republic',
      urlFriendlyName: 'czech-republic',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Budapest',
      urlFriendlyName: 'budapest',
    },
    country: {
      name: 'Hungary',
      urlFriendlyName: 'hungary',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Florence',
      urlFriendlyName: 'florence',
    },
    country: {
      name: 'Italy',
      urlFriendlyName: 'italy',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Milan',
      urlFriendlyName: 'milan',
    },
    country: {
      name: 'Italy',
      urlFriendlyName: 'italy',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Vienna',
      urlFriendlyName: 'vienna',
    },
    country: {
      name: 'Austria',
      urlFriendlyName: 'austria',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Porto',
      urlFriendlyName: 'porto',
    },
    country: {
      name: 'Portugal',
      urlFriendlyName: 'portugal',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Dublin',
      urlFriendlyName: 'dublin',
    },
    country: {
      name: 'Ireland',
      urlFriendlyName: 'ireland',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Athens',
      urlFriendlyName: 'athens',
    },
    country: {
      name: 'Greece',
      urlFriendlyName: 'greece',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Copenhagen',
      urlFriendlyName: 'copenhagen',
    },
    country: {
      name: 'Denmark',
      urlFriendlyName: 'denmark',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Munich',
      urlFriendlyName: 'munich',
    },
    country: {
      name: 'Germany',
      urlFriendlyName: 'germany',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Venice',
      urlFriendlyName: 'venice',
    },
    country: {
      name: 'Italy',
      urlFriendlyName: 'italy',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Edinburgh',
      urlFriendlyName: 'edinburgh',
    },
    country: {
      name: 'Scotland',
      urlFriendlyName: 'scotland',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Split',
      urlFriendlyName: 'split',
    },
    country: {
      name: 'Croatia',
      urlFriendlyName: 'croatia',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Brussels',
      urlFriendlyName: 'brussels',
    },
    country: {
      name: 'Belgium',
      urlFriendlyName: 'belgium',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Istanbul',
      urlFriendlyName: 'istanbul',
    },
    country: {
      name: 'Turkey',
      urlFriendlyName: 'turkey',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Bangkok',
      urlFriendlyName: 'bangkok',
    },
    country: {
      name: 'Thailand',
      urlFriendlyName: 'thailand',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Hanoi',
      urlFriendlyName: 'hanoi',
    },
    country: {
      name: 'Vietnam',
      urlFriendlyName: 'vietnam',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Chiang Mai',
      urlFriendlyName: 'chiang-mai',
    },
    country: {
      name: 'Thailand',
      urlFriendlyName: 'thailand',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Canggu',
      urlFriendlyName: 'canggu',
    },
    country: {
      name: 'Indonesia',
      urlFriendlyName: 'indonesia',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Hoi An',
      urlFriendlyName: 'hoi-an',
    },
    country: {
      name: 'Vietnam',
      urlFriendlyName: 'vietnam',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Ho Chi Minh',
      urlFriendlyName: 'ho-chi-minh',
    },
    country: {
      name: 'Vietnam',
      urlFriendlyName: 'vietnam',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Ubud',
      urlFriendlyName: 'ubud',
    },
    country: {
      name: 'Indonesia',
      urlFriendlyName: 'indonesia',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Tokyo',
      urlFriendlyName: 'tokyo',
    },
    country: {
      name: 'Japan',
      urlFriendlyName: 'japan',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Krabi',
      urlFriendlyName: 'krabi',
    },
    country: {
      name: 'Thailand',
      urlFriendlyName: 'thailand',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Uluwatu',
      urlFriendlyName: 'uluwatu',
    },
    country: {
      name: 'Indonesia',
      urlFriendlyName: 'indonesia',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Phuket',
      urlFriendlyName: 'phuket',
    },
    country: {
      name: 'Thailand',
      urlFriendlyName: 'thailand',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Koh Samui',
      urlFriendlyName: 'koh-samui',
    },
    country: {
      name: 'Thailand',
      urlFriendlyName: 'thailand',
    },
  },
  {
    continent: {
      name: 'Asia',
      urlFriendlyName: 'asia',
    },
    city: {
      name: 'Kuala Lumpur',
      urlFriendlyName: 'kuala-lumpur',
    },
    country: {
      name: 'Malaysia',
      urlFriendlyName: 'malaysia',
    },
  },
  {
    continent: {
      name: 'North America',
      urlFriendlyName: 'north-america',
    },
    city: {
      name: 'New York',
      urlFriendlyName: 'new-york',
    },
    country: {
      name: 'USA',
      urlFriendlyName: 'usa',
    },
  },
  {
    continent: {
      name: 'North America',
      urlFriendlyName: 'north-america',
    },
    city: {
      name: 'Mexico City',
      urlFriendlyName: 'mexico-city',
    },
    country: {
      name: 'Mexico',
      urlFriendlyName: 'mexico',
    },
  },
  {
    continent: {
      name: 'North America',
      urlFriendlyName: 'north-america',
    },
    city: {
      name: 'Antigua',
      urlFriendlyName: 'antigua',
    },
    country: {
      name: 'Guatemala',
      urlFriendlyName: 'guatemala',
    },
  },
  {
    continent: {
      name: 'South America',
      urlFriendlyName: 'south-america',
    },
    city: {
      name: 'Cusco',
      urlFriendlyName: 'cusco',
    },
    country: {
      name: 'Peru',
      urlFriendlyName: 'peru',
    },
  },
  {
    continent: {
      name: 'South America',
      urlFriendlyName: 'south-america',
    },
    city: {
      name: 'Lima',
      urlFriendlyName: 'lima',
    },
    country: {
      name: 'Peru',
      urlFriendlyName: 'peru',
    },
  },
  {
    continent: {
      name: 'South America',
      urlFriendlyName: 'south-america',
    },
    city: {
      name: 'Medellin',
      urlFriendlyName: 'medellin',
    },
    country: {
      name: 'Colombia',
      urlFriendlyName: 'colombia',
    },
  },
  {
    continent: {
      name: 'South America',
      urlFriendlyName: 'south-america',
    },
    city: {
      name: 'Santa Marta',
      urlFriendlyName: 'santa-marta',
    },
    country: {
      name: 'Colombia',
      urlFriendlyName: 'colombia',
    },
  },
  {
    continent: {
      name: 'Oceania',
      urlFriendlyName: 'oceania',
    },
    city: {
      name: 'Sydney',
      urlFriendlyName: 'sydney',
    },
    country: {
      name: 'Australia',
      urlFriendlyName: 'australia',
    },
  },
  {
    continent: {
      name: 'Oceania',
      urlFriendlyName: 'oceania',
    },
    city: {
      name: 'Melbourne',
      urlFriendlyName: 'melbourne',
    },
    country: {
      name: 'Australia',
      urlFriendlyName: 'australia',
    },
  },
  {
    continent: {
      name: 'Oceania',
      urlFriendlyName: 'oceania',
    },
    city: {
      name: 'Cairns',
      urlFriendlyName: 'cairns',
    },
    country: {
      name: 'Australia',
      urlFriendlyName: 'australia',
    },
  },
  {
    continent: {
      name: 'Oceania',
      urlFriendlyName: 'oceania',
    },
    city: {
      name: 'Auckland',
      urlFriendlyName: 'auckland',
    },
    country: {
      name: 'New Zealand',
      urlFriendlyName: 'new-zealand',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Como',
      urlFriendlyName: 'como',
    },
    country: {
      name: 'Italy',
      urlFriendlyName: 'italy',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Krakow',
      urlFriendlyName: 'krakow',
    },
    country: {
      name: 'Poland',
      urlFriendlyName: 'poland',
    },
  },
  {
    continent: {
      name: 'Europe',
      urlFriendlyName: 'europe',
    },
    city: {
      name: 'Valencia',
      urlFriendlyName: 'valencia',
    },
    country: {
      name: 'Spain',
      urlFriendlyName: 'spain',
    },
  },
];

export const DEFAULT_SEO_META_DATA = {
  aboutSection: {
    worldwide: `
      <h2>Events You Can't Miss in ##YEAR##</h2>
      <h3>Big stages, local vibes, global stories</h3>
      <p>Events aren't just dates on a calendar — they're reasons to pack a bag. From massive music festivals and international sports tournaments to food fairs, cultural celebrations, and underground gigs, ##YEAR## is stacked with experiences worth travelling for. Some take over entire cities. Others bring local neighbourhoods to life. All of them are better when shared.</p>
      <p>That's where Hostelworld comes in. We help you stay close to the action with social, budget-friendly hostels backed by real traveller reviews. Whether you're planning around one headline event or building a full trip around multiple stops, you'll find places designed for meeting people, not just sleeping. And with the Hostelworld App, you can connect with other travellers before you even arrive — so the event starts long before the doors open.</p>
      <p><strong>Because in ##YEAR##, the real question isn't if you're travelling — it's what you're travelling for.</strong>.</p>`,
    continent: `
      <h2>##LOCATIONNAME## Events you can't miss in ##YEAR##</h2>
      <p>From one country to the next, ##LOCATIONNAME## always has something worth planning a stop around. ##YEAR## brings a huge spread of festivals, gigs, markets, and celebrations as varied as the region itself.</p>
      <p>That's where Hostelworld comes in. With ##PROPCOUNT## places to stay across ##LOCATIONNAME## and ##REVIEWSCOUNT## reviews from real travellers, you can book somewhere that suits your route and know what to expect before you arrive. Don't want to do it solo? The Hostelworld app helps you connect with other travellers nearby, so a crew for the next event is easy to find. ##LOCATIONNAME## in ##YEAR## is one big reason to keep moving.</p>`,
    country: `
      <h2><span>##LOCATIONNAME##</span> Events you can’t miss in ##YEAR##</h2>
      <p>Wherever you're headed in ##LOCATIONNAME##, there's usually a reason to plan the trip around what's on. With ##EVENTSCOUNT## events lined up for ##YEAR##, you can build days around live music, local festivals, markets, and the kind of nights that turn into the stories you tell later.</p>
      <p>Hostelworld handles the logistics: pick from ##PROPCOUNT## places to stay across ##LOCATIONNAME## and check real traveller feedback from ##REVIEWSCOUNT## reviews before you book. Travelling solo? The Hostelworld app helps you connect with other travellers nearby, so finding people to share an event with is never far off. ##COUNTRYSEARCHURL##Explore stays in ##LOCATIONNAME####ENDCOUNTRYSEARCHURL##.</p>`,
    city: `
      <h2><span>##LOCATIONNAME##</span> Events you can’t miss in ##YEAR##</h2>
      <p>In ##LOCATIONNAME##, events aren't just something you go to - they're where the best stories start. With ##EVENTSCOUNT## events to choose from, you can chase live music, street parties, cultural nights, pop-ups, and last-minute "we're going" plans. That's where Hostelworld comes in. With ##PROPCOUNT## places to stay in ##LOCATIONNAME##, you can book close to venues, nightlife, and the transport links that get you home safely after the fun. Plus, with ##REVIEWSCOUNT## reviews from real travellers, you can vibe-check before you commit - no surprises.</p>
      <p>And you don't have to do ##LOCATIONNAME## solo. The Hostelworld App helps you connect with other travellers nearby, so it's easy to find a crew for a gig, a festival day, or a spontaneous bar hop. Travelling beyond ##LOCATIONNAME##? ##COUNTRYSEARCHURL##Explore ##CHOSENCOUNTRY## stays here.##ENDCOUNTRYSEARCHURL##</p>`,
  },
};
